// Set webpack public path for dynamic chunk loading BEFORE any imports
// This must be done before any code-split modules are loaded
// eslint-disable-next-line import/first
if (typeof window !== 'undefined') {
  const getBasePath = (): string => {
    // At runtime, get from window.env (set by entrypoint script)
    // At build time, use process.env (for build-time substitution)
    const envBasePath = (window as any).env?.REACT_APP_BASE_PATH || 
                        (typeof process !== 'undefined' && (process as any).env?.REACT_APP_BASE_PATH) || 
                        '';
    console.log('[index.tsx] Raw envBasePath:', envBasePath);
    if (envBasePath && envBasePath !== '') {
      const normalized = envBasePath.startsWith('/') ? envBasePath : `/${envBasePath}`;
      console.log('[index.tsx] Normalized base path:', normalized);
      return normalized;
    }
    console.warn('[index.tsx] No base path found, using empty string');
    return '';
  };
  
  const basePath = getBasePath();
  const publicPath = basePath + '/';
  
  console.log('[index.tsx] Setting webpack public path to:', publicPath);
  console.log('[index.tsx] Current __webpack_public_path__:', (window as any).__webpack_public_path__);
  
  // Set webpack public path for webpack 5 (react-scripts 5.x)
  (window as any).__webpack_public_path__ = publicPath;
  
  // Also set it globally for webpack runtime
  if (typeof (global as any) !== 'undefined') {
    (global as any).__webpack_public_path__ = publicPath;
  }
  
  // Set it on globalThis as well
  if (typeof globalThis !== 'undefined') {
    (globalThis as any).__webpack_public_path__ = publicPath;
  }
  
  // CRITICAL: Override webpack's chunk loading to use correct public path
  // This ensures chunks load from the correct base path even if webpack runtime
  // was initialized before we set the public path
  const ensureWebpackPublicPath = () => {
    // Set __webpack_require__.p which is what webpack actually uses for chunk loading
    if (typeof (window as any).__webpack_require__ !== 'undefined') {
      (window as any).__webpack_require__.p = publicPath;
      console.log('[index.tsx] Set __webpack_require__.p to:', publicPath);
      
      // Override the chunk loading function if it exists
      if (typeof (window as any).__webpack_require__.e !== 'undefined') {
        const originalE = (window as any).__webpack_require__.e;
        if (!originalE.__overridden) {
          (window as any).__webpack_require__.e = function(chunkId: any) {
            // Ensure public path is set before loading
            (window as any).__webpack_require__.p = publicPath;
            console.log('[index.tsx] Loading chunk with public path:', publicPath, 'chunkId:', chunkId);
            return originalE(chunkId);
          };
          (window as any).__webpack_require__.e.__overridden = true;
          console.log('[index.tsx] Overrode __webpack_require__.e');
        }
      }
    }
  };
  
  // Try to override immediately
  ensureWebpackPublicPath();
  
  // Also try after a delay in case webpack hasn't loaded yet
  setTimeout(ensureWebpackPublicPath, 0);
  setTimeout(ensureWebpackPublicPath, 10);
  setTimeout(ensureWebpackPublicPath, 50);
  
  // Verify it was set correctly
  console.log('[index.tsx] After setting - window.__webpack_public_path__:', (window as any).__webpack_public_path__);
  console.log('[index.tsx] After setting - globalThis.__webpack_public_path__:', (globalThis as any).__webpack_public_path__);
  if (typeof (window as any).__webpack_require__ !== 'undefined') {
    console.log('[index.tsx] __webpack_require__.p:', (window as any).__webpack_require__.p);
  }
}

/* eslint-disable import/first */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'; // Import the global CSS file
import App from './App';
/* eslint-enable import/first */

ReactDOM.render(
  <App />,
  document.getElementById('root')
);